import { createSlice } from "@reduxjs/toolkit";
import { logoutUser } from "../actions/account";

export const PAGE_LIST_DEFAULTS = {
    constructions: {
        filters: {
            search: "",
            move_required: "",
            dateFrom: "",
            dateTo: "",
        },
        columnFilters: {},
        sort: null,
        pageSize: 20,
        visibleColumnIds: [
            "title",
            "unit",
            "household",
            "move_required",
            "move_status",
            "construction_type",
            "construction_start_date",
            "construction_end_date",
            "temporary_unit",
            "household_ready_by_date",
        ],
    },
    constructionMatrix: {
        filters: {
            search: "",
            move_required: "",
            cohortId: "all",
        },
        columnFilters: {},
        sort: null,
        pageSize: 30,
        visibleColumnIds: [],
    },
};

const FALLBACK_DEFAULTS = {
    filters: {},
    columnFilters: {},
    sort: null,
    pageSize: 20,
    visibleColumnIds: [],
};

export const getPageListDefaults = (pageKey) => {
    const defaults = PAGE_LIST_DEFAULTS[pageKey] || FALLBACK_DEFAULTS;

    return {
        ...defaults,
        filters: { ...defaults.filters },
        columnFilters: { ...defaults.columnFilters },
        sort: defaults.sort ? { ...defaults.sort } : null,
        visibleColumnIds: [...defaults.visibleColumnIds]
    }
}

const initialState = {
    byContext: {},
};

const getOrCreatePreferences = (state, contextKey, pageKey) => {
    if (!state.byContext[contextKey]) {
        state.byContext[contextKey] = getPageListDefaults(pageKey);
    }

    return state.byContext[contextKey];
};

const listViewPreferencesSlice = createSlice({
    name: "listViewPreferences",
    initialState,
    reducers: {
        setPageFilters(state, action) {
            const { contextKey, pageKey, filters } = action.payload;
            getOrCreatePreferences(state, contextKey, pageKey).filters = filters;
        },
        setPageColumnFilters(state, action) {
            const { contextKey, pageKey, columnFilters } = action.payload;
            getOrCreatePreferences(state, contextKey, pageKey).columnFilters = columnFilters;
        },
        setPageSort(state, action) {
            const { contextKey, pageKey, sort } = action.payload;
            getOrCreatePreferences(state, contextKey, pageKey).sort = sort;
        },
        setPageSize(state, action) {
            const { contextKey, pageKey, pageSize } = action.payload;
            getOrCreatePreferences(state, contextKey, pageKey).pageSize = pageSize;
        },
        setPageVisibleColumnIds(state, action) {
            const { contextKey, pageKey, visibleColumnIds } = action.payload;
            getOrCreatePreferences(state, contextKey, pageKey).visibleColumnIds =
                visibleColumnIds;
        },
        resetPagePreferences(state, action) {
            delete state.byContext[action.payload.contextKey];
        },
    },
    extraReducers: {
        [logoutUser.fulfilled]: () => initialState,
        [logoutUser.rejected]: () => initialState,
    },
});

export const {
    setPageFilters, setPageColumnFilters, setPageSort, setPageSize, setPageVisibleColumnIds, resetPagePreferences
} = listViewPreferencesSlice.actions;

export default listViewPreferencesSlice;
